// import countries from "./area-settings/countries"

import home from "@admin/home";
import user from "@admin/user";

export default {
    // countries,
    home,
    user
};
